import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
  },
  offeringSelect: {
    width: '100%',
  },
  field: {
    width: '100%',
  },
  iconButton: {
    padding: [12, 2],
  },
  fieldLabel: {
    marginBottom: theme.spacing(1),
  },
  marginLeft: {
    marginLeft: theme.spacing(2),
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOptions/components/BidPage/components/BidForm/useStyles.js